import React, { useState } from "react";

import { Tab } from "clearsense-ui/components";

import SurvivorshipDomainDetails from "../SurvivorshipDomainDetails";
import SurvivorshipDomainRecord from "../SurvivorshipDomainRecord";

const Tabs = ({
  recordDetails,
  searchIdentifier,
  tableData,
  cdeFilters,
  cdes,
  businessRules,
  setTableData,
  setCdeFilters,
}) => {
  const [activeTab, setActiveTab] = useState("record");

  return (
    <div>
      <Tab style="secondary">
        <Tab.Item
          active={activeTab === "record"}
          onClick={() => setActiveTab("record")}
        >
          Record
        </Tab.Item>
        <Tab.Item
          active={activeTab === "details"}
          onClick={() => setActiveTab("details")}
        >
          Details
        </Tab.Item>
      </Tab>
      {activeTab === "record" && (
        <SurvivorshipDomainRecord
          recordDetails={recordDetails}
          businessRules={businessRules}
          searchIdentifier={searchIdentifier}
        />
      )}
      {activeTab === "details" && (
        <SurvivorshipDomainDetails
          recordDetails={recordDetails}
          searchIdentifier={searchIdentifier}
          tableData={tableData}
          cdeFilters={cdeFilters}
          cdes={cdes}
          businessRules={businessRules}
          setTableData={setTableData}
          setCdeFilters={setCdeFilters}
        />
      )}
    </div>
  );
};

export default Tabs;
